<template>
  <div class="hello" style="background-color: #e8e8e8; min-height: 100vh">
    <div style="padding: 10px 10px">
      <div class="C-wrap">
        <div class="wj-title">稳进提质</div>
        <!-- 切换 -->
        <van-tabs v-model="active" color="#00a0e9" line-width="3.5em">
          <van-tab :title="tabName[0]"></van-tab>
          <van-tab :title="tabName[1]"></van-tab>
          <van-tab :title="tabName[2]"></van-tab>
        </van-tabs>
      </div>
      <div class="tab-content" style="width: 100%">
        <div  style="width: 100%" v-if="active == 0">
          <LiDaBaoBiao></LiDaBaoBiao>
        </div>
        <div v-if="active == 1">
          <ZhengCeDuiXian></ZhengCeDuiXian>
        </div>
        <div v-if="active == 2">
          <QiYeFuWu></QiYeFuWu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiDaBaoBiao from './Wjtz-component1.vue'
import ZhengCeDuiXian from './Wjtz-component2.vue'
import QiYeFuWu from './Wjtz-component3.vue'

export default {
  name: 'Wjtz',
  components: { ZhengCeDuiXian, QiYeFuWu, LiDaBaoBiao },
  data() {
    return {
      active: 0,
      tabName: ['"月晾晒"指标', '政策兑现', '企业服务'],
    }
  },
  mounted() {},
  created() {},
  destroyed() {},
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.C-wrap {
  background-color: #fff;
  padding: 25px 17px 0;
  border-radius: 4px 4px 0 0;
}
.wj-title {
  border-left: 2px solid #00a0e9;
  color: #333333;
  font-size: 17px;
  text-align: left;
  padding-left: 10px;
  line-height: 1;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wjtz.vue